import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { ChatWrapperComponent } from './components/chat-wrapper/chat-wrapper.component';

export const routes: Routes = [
    { path: '', component: ChatWrapperComponent },
    {
        path: 'unity-mx',
        component: ChatWrapperComponent,
        data: {
            themeOverride: 'aura__platform-unity-mx'
        }
    },
    {
        path: 'unity-fc',
        component: ChatWrapperComponent,
        data: {
            themeOverride: 'aura__platform-unity-fc'
        }
    },
    {
        path: 'fc-plus',
        component: ChatWrapperComponent,
        data: {
            themeOverride: 'aura__platform-fc-plus'
        }
    },
    {
        path: 'mfm',
        component: ChatWrapperComponent,
        data: {
            themeOverride: 'aura__platform-mfm'
        }
    },
    { path: 'login', component: LoginComponent },
    { path: '**', redirectTo: '/', pathMatch: 'full' }
];